/* Dear V R17: Spanish labels on Shopify's native consent UI. Consent controls remain native. */
(() => {
  const selector = '#shopify-pc__banner, #shopify-pc__prefs';
  const translations = new Map([
    ['Cookie consent', 'Privacidad y Cookies'],
    ['Accept', 'Aceptar todas'],
    ['Decline', 'Solo esenciales'],
    ['Manage preferences', 'Preferencias'],
    ['Cookie and privacy preferences', 'Privacidad y Cookies'],
    ['Accept all', 'Aceptar todas'],
    ['Decline all', 'Solo esenciales'],
    ['Save my choices', 'Guardar mis preferencias'],
    ['You control your data', 'Tú decides sobre tus datos'],
    ['Learn more about the cookies we use, and choose which cookies to allow.', 'Conoce las cookies que utilizamos y elige cuáles quieres permitir.'],
    ['Required', 'Esenciales'],
    ['Personalization', 'Personalización'],
    ['Marketing', 'Publicidad'],
    ['Analytics', 'Analítica'],
    ['Privacy Policy', 'Política de privacidad'],
    ['These cookies are necessary for the site to function properly, including capabilities like logging in and adding items to the cart.', 'Estas cookies son necesarias para que la web funcione correctamente, por ejemplo, para iniciar sesión o añadir productos a tu bolsa.'],
    ['These cookies store details about your actions to personalize your next visit to the website.', 'Estas cookies guardan información sobre tus acciones para personalizar tu próxima visita a la web.'],
    ['These cookies are used by us and our partners, including Shopify, to optimize marketing communications and show you ads on other websites.', 'Nosotros y nuestros colaboradores, incluido Shopify, utilizamos estas cookies para mejorar las comunicaciones comerciales y mostrarte anuncios en otras webs.'],
    ['These cookies help us understand how you interact with the site. We use this data to identify areas to improve.', 'Estas cookies nos ayudan a entender cómo utilizas la web. Usamos estos datos para identificar qué podemos mejorar.'],
    ['We and our partners, including Shopify, use cookies and other technologies to personalize your experience, show you ads, and perform analytics, and we will not use cookies or other technologies for these purposes unless you accept them. Learn more in our', 'Nosotros y nuestros colaboradores, incluido Shopify, utilizamos cookies y otras tecnologías para personalizar tu experiencia, mostrarte anuncios y realizar análisis. No las utilizaremos con estos fines a menos que las aceptes. Más información en nuestra']
  ]);
  let queued = false;
  const translate = () => {
    queued = false;
    document.querySelectorAll(selector).forEach(root => {
      root.lang = 'es';
      const walker = document.createTreeWalker(root, NodeFilter.SHOW_TEXT);
      let node;
      while ((node = walker.nextNode())) {
        const value = node.nodeValue;
        const translated = translations.get(value.trim());
        if (translated) node.nodeValue = value.replace(value.trim(), translated);
      }
      root.querySelectorAll('[aria-label="Close dialog"]').forEach(button => button.setAttribute('aria-label', 'Cerrar preferencias'));
    });
  };
  const queue = () => {
    if (queued) return;
    queued = true;
    requestAnimationFrame(translate);
  };
  const init = () => {
    translate();
    new MutationObserver(records => {
      if (records.some(record => record.target.parentElement?.closest(selector) || record.target.closest?.(selector) || [...record.addedNodes].some(node => node.nodeType === Node.ELEMENT_NODE && (node.matches(selector) || node.querySelector(selector))))) queue();
    }).observe(document.body, { childList: true, characterData: true, subtree: true });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
